<template>
  <div class="qty-selector">
    <div class="qty"
         v-for="qty in quantities" v-bind:key="qty"
         :class="{ 'is-selected': quantity === qty }"
         @click="select(qty)">
      {{ qty }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuantitySelector',
  props: {
    quantities: {
      type: Array,
    },
    quantity: {
      type: Number,
    },
  },
  methods: {
    select(qty) {
      this.$emit('selectionChanged', qty);
    },
  },
};
</script>

<style lang="scss" scoped>

.qty-selector {
  display: flex;
  border: solid 0.1rem #00000033;
  border-radius: 0.6rem;
  background: #ffffff33;
  box-shadow: 0 0.1rem 0.3rem #00000033;
  overflow: hidden;

  .qty {
    padding: 0.5rem 1rem;
    color: #00000044;
    cursor: pointer;
    font-weight: 600;

    &.is-selected {
      background: #fff;
      color: #333;
      border-radius: 0.6rem;
      box-shadow: 0 0 0.5rem #00000066;
      animation: bounce-in .2s;
    }
  }
}

</style>
